/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum VersionListAliases {
  AUTOCOMPLETE_APPLICATION = 'autocomplete-application',
  CHECKBOX_PRIORITY = 'checkbox-priority',
  CONTEXTUAL_BAR_VERSION = 'contextual-bar-version',
  FETCH_APPLICATION = 'fetch-application',
  FETCH_VERSION = 'fetch-version',
  FIELD_APPLICATION = 'field-application',
  FIELD_EXCLUSIVE = 'field-exclusive',
  FIELD_VERSION = 'field-version',
  FILTER_VERSIONS = 'filter-versions',
  FILTERED_LIST_0 = 'filtered-list-0',
  INPUT_VERSION = 'input-version',
  LAYOUT_VERSION = 'layout-version',
  MAPPER_APPLICATION = 'mapper-application',
  PAGINATOR_VERSION = 'paginator-version',
  PANEL_LIST = 'panel-list',
  TABLE_COLUMN_APPLICATION_NAME = 'table-column-application-name',
  TABLE_COLUMN_DATE_MODIFIED = 'table-column-date-modified',
  TABLE_COLUMN_EXCLUSIVE_CHECK = 'table-column-exclusive-check',
  TABLE_COLUMN_VERSION_ACTIONS = 'table-column-version-actions',
  TABLE_COLUMN_VERSION_NUMBER = 'table-column-version-number',
  TABLE_VERSION = 'table-version',
  TEXT_APPLICATION = 'text-application',
}
export { VersionListAliases };
